import { useEffect } from "react"
import {useNavigate, useSearchParams} from "react-router-dom"
import * as Sentry from "@sentry/react"


export function CheckoutCancelled() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    useEffect(() => {
        const from = searchParams.get("from") ?? "/"
        console.log("Checkout was cancelled")
        Sentry.captureMessage("Checkout was cancelled", { level: "log" })
        navigate(from)
    }, [searchParams, navigate])

    return null  // Nothing to render
}